import React from 'react';
import './shared.css';

const ConfidencePill = ({ level }) => {
  const config = {
    high: { icon: '▲', label: 'HIGH', className: 'confidence-high' },
    medium: { icon: '◆', label: 'MED', className: 'confidence-med' },
    low: { icon: '○', label: 'LOW', className: 'confidence-low' }
  };
  
  const { icon, label, className } = config[level?.toLowerCase()] || config.medium;
  
  return (
    <span className={`confidence-pill ${className}`}>
      <span className="confidence-icon">{icon}</span>
      {label}
    </span>
  );
};

export default ConfidencePill;
